// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TcYSw7pGjxMd5FvMN7W8{border-right:1px solid var(--border-neutral-default)}.SalXXEhvXug4Hg2UJpJC{grid-template-rows:48px 1fr;display:grid}.SalXXEhvXug4Hg2UJpJC.U6lRVRN80k4HmaWxRPni{grid-template-rows:1fr}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `TcYSw7pGjxMd5FvMN7W8`,
	"content": `SalXXEhvXug4Hg2UJpJC`,
	"hideFilter": `U6lRVRN80k4HmaWxRPni`
};
export default ___CSS_LOADER_EXPORT___;
